import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-lead-generation',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './lead-generation.html',
  styleUrl: './lead-generation.css'
})
export class LeadGenerationComponent {
  features = [
    {
      icon: 'bi-ui-checks',
      title: 'Lead Capture Forms',
      description: 'Custom-designed forms optimized for conversion with smart field validation, progressive profiling, and A/B testing capabilities.'
    },
    {
      icon: 'bi-diagram-3',
      title: 'CRM Integration',
      description: 'Seamless integration with major CRM platforms including Salesforce, HubSpot, and Zoho for automatic lead syncing and data enrichment.'
    },
    {
      icon: 'bi-star',
      title: 'Lead Scoring',
      description: 'Intelligent scoring algorithms that prioritize leads based on engagement, demographics, and behavior patterns to focus on high-value prospects.'
    },
    {
      icon: 'bi-arrow-repeat',
      title: 'Nurturing Workflows',
      description: 'Automated email sequences and multi-channel campaigns that guide leads through the sales funnel with personalized content.'
    },
    {
      icon: 'bi-hand-thumbs-up',
      title: 'Sales Handoff',
      description: 'Streamlined processes for qualifying and transferring marketing-qualified leads to sales teams with complete context and history.'
    },
    {
      icon: 'bi-graph-up',
      title: 'Analytics & Reporting',
      description: 'Comprehensive dashboards tracking lead sources, conversion rates, pipeline velocity, and ROI across all channels.'
    }
  ];

  process = [
    {
      step: '01',
      title: 'Strategy & Planning',
      description: 'We analyze your target audience, buying journey, and sales process to design a comprehensive lead generation strategy aligned with your business goals.'
    },
    {
      step: '02',
      title: 'System Setup & Integration',
      description: 'Implementation of lead capture mechanisms, CRM integration, scoring models, and automation workflows tailored to your specific requirements.'
    },
    {
      step: '03',
      title: 'Campaign Execution',
      description: 'Launch of multi-channel campaigns with optimized landing pages, forms, and nurturing sequences designed to attract and convert quality leads.'
    },
    {
      step: '04',
      title: 'Optimization & Scale',
      description: 'Continuous monitoring, testing, and refinement of lead generation tactics to improve quality, reduce cost per lead, and maximize ROI.'
    }
  ];

  caseStudy = {
    client: 'TechVenture Solutions',
    industry: 'B2B SaaS',
    image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&h=500&fit=crop',
    challenge: 'TechVenture Solutions struggled with low-quality leads and a 2% conversion rate from their website. Their sales team spent 70% of their time qualifying unqualified prospects, resulting in lost opportunities and inefficient resource allocation.',
    solution: 'We implemented a complete lead generation overhaul including progressive profiling forms, behavioral lead scoring, automated nurturing campaigns, and CRM integration. Smart segmentation ensured only sales-ready leads reached the sales team.',
    results: [
      '425% increase in marketing-qualified leads',
      '68% improvement in lead-to-opportunity conversion rate',
      '52% reduction in cost per qualified lead',
      '3.2x increase in sales team productivity'
    ]
  };

  testimonial = {
    quote: 'HoneyKode transformed our lead generation process from a chaotic funnel into a well-oiled machine. The quality of leads has improved dramatically, and our sales team now focuses on closing deals instead of chasing unqualified prospects. The ROI has been exceptional.',
    author: 'Michael Chen',
    role: 'VP of Marketing',
    company: 'TechVenture Solutions',
    image: 'https://i.pravatar.cc/150?img=12'
  };
}
